import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable()
export class AuthGuard implements CanActivate {
    constructor(private authService: AuthService) {
    }

    public canActivate(): boolean {
        if (this.authService.isLoggedIn()) {
            return true;
        }
        this.authService.goToLogin();
        return false;
    }
}



// WEBPACK FOOTER //
// ./src/app/core/auth.guard.ts